import { render, staticRenderFns } from "./RestaurarClave.vue?vue&type=template&id=6379a8f0&"
import script from "./RestaurarClave.vue?vue&type=script&lang=js&"
export * from "./RestaurarClave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports